module.exports = new __parcel__URL__("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg").toString();